module.exports = __webpack_public_path__ + "img/public/SiteIcons/noItemCars.svg?8817bcdd";